import React, { useState, useEffect } from 'react';
import { fetchOrCreateCart } from 'js/services/cartService';

/* Symbols */
import cartIcon from 'symbols/cart.svg';

/* Atoms */
import { Icon } from 'js/components/atoms';

export default function CartIcon({ shopwareUrl, cartUrl, mobile = false }) {
    const [cartCount, setCartCount] = useState(0);
    const [isLoading, setIsLoading] = useState(false);

    const loadCartCount = async () => {
        if (!shopwareUrl) return;

        setIsLoading(true);
        try {
            // Fetch or create cart function
            const cartData = await fetchOrCreateCart({ shopwareUrl });
            const totalQuantity = cartData?.lineItems?.reduce((total, item) => {
                return total + (item.quantity || 0);
            }, 0) || 0;
            setCartCount(totalQuantity);
        } catch (error) {
            setCartCount(0);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        loadCartCount();
    }, [shopwareUrl]);

    // Listen for cart update events
    useEffect(() => {
        const handleCartUpdate = () => {
            loadCartCount();
        };

        window.addEventListener('cart:updated', handleCartUpdate);
        return () => {
            window.removeEventListener('cart:updated', handleCartUpdate);
        };
    }, []);

    const handleClick = (e) => {
        e.preventDefault();
        if (cartUrl) {
            window.location.href = cartUrl;
        }
    };

    return (
        <button
            className="btn btn-none btn-cart"
            onClick={handleClick}
            disabled={isLoading}
            title="Shop"
        >
            <div className="btn__icon">
                <Icon url={cartIcon.url} size={mobile ? 20 : 24} theme="base" />
                {cartCount > 0 && (
                    <span className="main-header__cart-badge">
                        {cartCount > 99 ? '99+' : cartCount}
                    </span>
                )}
            </div>
            <span className="d-none d-xl-block btn__text">
                Winkelwagen
            </span>
        </button>
    );
}
